import React from 'react';
import PropTypes from 'prop-types';

import { TableBody as MuiTableBody } from '@material-ui/core';

const TableBody = ({ children, ...rest }) => {
  return (
    <MuiTableBody
      {...rest}
    >
      { children }
    </MuiTableBody>
  )
}

TableBody.defaultProps = {
  children: null,
};

TableBody.propTypes = {
  children: PropTypes.node,
};

export default TableBody;



// WEBPACK FOOTER //
// ./src/components/base/TableBody/TableBody.js